import { ConnectionAuthInfo } from '../types/IConnectionAuthInfo';
import { UnencryptedConnectionKeychain } from '../types/IConnectionKeyChain';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IRevertWorkbookParams {
  id: string;
  version: number;
  keychains?: UnencryptedConnectionKeychain[];
  encryptedPasswordKeyId?: string;
}

export interface IRevertWorkbookResult extends IResult {
  failedConnection?: ConnectionAuthInfo;
  scheduledExtractCredentialsMayNotBeRestored?: boolean;
}

export class RevertWorkbookRequest extends Request<IRevertWorkbookParams, IRevertWorkbookResult> {
  constructor(params: IRevertWorkbookParams) {
    super('revertWorkbook', params);
  }
}
